import type {
  DashboardFinanceiroApiResponse,
  DashboardFinanceiroViewModel,
} from "../types/financeiro-dashboard.types";

export function mapDashboardApiToView(
  api: DashboardFinanceiroApiResponse,
): DashboardFinanceiroViewModel {
  const vencidosTotal =
    (api.titulos?.receberVencido ?? 0) + (api.titulos?.pagarVencido ?? 0);

  return {
    caixa: {
      saldoAtual: api.caixa?.saldoTotal ?? 0,
      saldoEfi: api.caixa?.saldoGatewayEfi ?? 0,
      saldoBancos: api.caixa?.saldoBancos ?? 0,
      entradasHoje: api.movimentacaoHoje?.entradas ?? 0,
      saidasHoje: api.movimentacaoHoje?.saidas ?? 0,
    },
    financeiro: {
      contasReceber: api.titulos?.receberAberto ?? 0,
      contasPagar: api.titulos?.pagarAberto ?? 0,
      vencidosTotal,
      previsaoReceber30Dias: api.titulos?.receberProximos30Dias ?? 0,
      previsaoPagar30Dias: api.titulos?.pagarProximos30Dias ?? 0,
    },
    vendas: {
      faturamentoBruto: api.vendas?.faturamentoBruto ?? 0,
      estornosTotal: api.vendas?.estornosTotal ?? 0,
      faturamentoLiquido: api.vendas?.faturamentoLiquido ?? 0,
      receitaPedidos: api.vendas?.receitaPedidos ?? 0,
      jurosParcelamentoTotal: api.vendas?.jurosParcelamentoTotal ?? 0,
      ticketMedio: api.vendas?.ticketMedio ?? 0,
      quantidadePedidos: api.vendas?.pedidosPagosQuantidade ?? 0,
    },
    inscricoes: {
      faturamentoBruto: api.inscricoes?.faturamentoBruto ?? 0,
      receitaInscricoes: api.inscricoes?.receitaInscricoes ?? 0,
      jurosParcelamentoTotal: api.inscricoes?.jurosParcelamentoTotal ?? 0,
      ticketMedio: api.inscricoes?.ticketMedio ?? 0,
      quantidadeInscricoes:
        api.inscricoes?.inscricoesComReceitaQuantidade ?? 0,
    },
  };
}
